jQuery(document).ready(function($) {
  $('.work-thumbnails-carousel').flickity({
    cellSelector: '.carousel-cell',
    pageDots: true,
    prevNextButtons: false,
    percentPosition: false,
    autoPlay: 0,
    pauseOnHover: false,
    draggable: true,
    resize: true,
    groupCells: 2,
    wrapAround: true
  })

})
